module.exports = "/video-roulette/img/fast-choosen-bck.png";


//////////////////
// WEBPACK FOOTER
// ./src/games/video-roulette/img/fast-choosen-bck.png
// module id = 378
// module chunks = 10